module.exports = __webpack_public_path__ + "media/images/hero-pattern-2-7b6e364b7178659246d2f97a85a455be.jpeg";